(function () {
    'use strict';

    angular.module("imApp").factory("timeSheetService", [function () {
        let service = {};

        return service;
    }]);
})();
